import { useTheme, Headline, Switch, Divider, Surface } from "react-native-paper";
import React from "react";
import { View, StyleSheet, Image } from "react-native";
import { Text } from "../../components/text/text";
import { ThemeType } from "../../theme/theme";
import { isBalanceError, toHumanDollars } from "../../utils/money";
import { BalanceDueUnavailableInfoBox } from "../balance-due-unavailable-info-box";
import { spacing } from "../../theme/spacing";
import { translate } from "../../i18n";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";
import { AppMode, PaymentActionTypes } from "../../enums";

// Extension to the header
export const BalanceDueExtension = ({ balance }: any) => {
  const theme = useTheme() as ThemeType;
  const { colors, fontSize } = theme;
  const appMode = useSelector((state: RootState) => state.reservation.appMode);

  const styles = StyleSheet.create({
    balanceDueContainer: {
      backgroundColor: "#FAFAFA",
      display: "flex",
      justifyContent: "space-around",
      flexDirection: "row",
      padding: 10,
    },
    balanceDueText: {
      color: theme.colors.darkGrey,
      fontSize: 16,
    },
    balanceAmountText: {
      color: theme.colors.darkGrey,
      fontSize: 16,
      fontWeight: "bold",
    },
  });

  const hasBalanceError = isBalanceError(balance);
  const balanceDouble = toHumanDollars(balance);

  if (hasBalanceError) {
    return <BalanceDueUnavailableInfoBox style={{ marginHorizontal: spacing.larger }} />;
  } else {
    return (
      <View style={styles.balanceDueContainer}>
        <Text style={styles.balanceDueText}>
          {appMode === AppMode.NORMAL
            ? translate("componentStatic.currentBalanceDue")
            : translate("componentStatic.outstandingBalanceDue")}
        </Text>
        <Text style={styles.balanceAmountText}>{balanceDouble}</Text>
      </View>
    );
  }
};
